import { getAdminStats } from '../../api/admin'
import { useFetch } from '../../hooks/useFetch'
import { StatCard } from './StatCard'

export function UsersByRoleWidget() {
  const { data: stats, loading } = useFetch(() => getAdminStats(), [])

  const staffCount = stats?.users_by_role['staff'] ?? 0
  const clientCount = stats?.users_by_role['client'] ?? 0
  const superAdminCount = stats?.users_by_role['super_admin'] ?? 0
  const pendingCount = stats?.users_by_role['user'] ?? 0

  return (
    <div>
      <div className="text-xs font-bold text-text-2 uppercase tracking-[0.06em] mb-3">
        Users by role
      </div>
      <div className="grid grid-cols-[repeat(auto-fill,minmax(160px,1fr))] gap-4">
        <StatCard label="Staff" value={loading ? undefined : staffCount} />
        <StatCard label="Clients" value={loading ? undefined : clientCount} />
        <StatCard label="Super admins" value={loading ? undefined : superAdminCount} />
        <StatCard label="Pending" value={loading ? undefined : pendingCount} sub="Awaiting staff role" warn />
      </div>
    </div>
  )
}
